

























import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import Form from '@/components/Form.vue'

export class EmbeddedContentType {
    public type = ''
    public name = ''
    public icon = ''
    public inputLabel = ''
    public validator?: (value: string) => true | string = () => true
}

/**
 * Muestra al usuario un widget donde puede seleccionar que contenido que incrustar en la página
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PageEmbeddedContent extends Vue {
    public $refs: {
        form: Form,
    }
    /**
     * Tipo de contenido actualmente seleccionado por el usuario
     */
    @Prop({type: String, default: ''})
    public type: string

    @Prop({type: String, default: ''})
    public content: string

    /**
     * Tipos de contenido incrustado
     */
    public types: EmbeddedContentType[] = [
        {
            type: 'google-forms',
            name: 'Formulario de Google',
            icon: 'mdi-google',
            inputLabel: 'Url del formulario de Google',
            validator: (value) =>  {
                const url = _.attempt(() => new URL(value) )
                if (_.isError(url)) {
                    return 'La url no es válida'
                }

                switch (true) {
                    case url.host !== 'docs.google.com':
                        return 'El dominio no pertenece a Google'
                    case !url.pathname.startsWith('/forms/d/e/'):
                        return 'La dirección no pertenece a un formulario válido'
                    default:
                        return true
                }
            },
        },
    ]

    public get typeConfig (): EmbeddedContentType {
        return this.types.find(t => t.type === this.type) || new EmbeddedContentType()
    }
}
